import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Profile',
  href: '#profile'
}, {
  label: 'Advisory',
  href: '#advisory'
}, {
  label: 'Career',
  href: '#career'
}, {
  label: 'Portfolio',
  href: '#portfolio'
}, {
  label: 'Expertise',
  href: '#expertise'
}];
interface NavigationProps {
  onRequestBriefing: () => void;
}
export function Navigation({
  onRequestBriefing
}: NavigationProps) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={['fixed inset-x-0 top-0 z-40 bg-white/95 backdrop-blur transition-[border-color,box-shadow] duration-200 ease-exec', scrolled ? 'border-b border-steel-100 shadow-[0_1px_2px_rgba(15,23,42,0.04)]' : 'border-b border-transparent'].join(' ')} data-id="element-159" data-mp="t03jnmr4okmc">
      <div className="mx-auto flex h-16 max-w-shell items-center justify-between px-6 lg:px-10" data-id="element-160" data-mp="hgj22lxae949">
        <a href="#top" className="focus-ring group flex items-baseline gap-2 rounded-sm" data-id="element-161" data-mp="mg4bxrdzw1vr">
          <span className="font-serif text-lg tracking-tight text-navy" data-id="element-162" data-mp="rg9xqqxl2u5x">
            Thomas R. Conroy
          </span>
          <span className="hidden text-[10px] font-medium uppercase tracking-overline text-steel-400 sm:inline" data-id="element-163" data-mp="webf97fd2lfa">
            Board Director
          </span>
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-164" data-mp="157wt8ojpbynn">
          {links.map(link => <a key={link.href} href={link.href} className="focus-ring rounded-sm text-sm font-medium text-steel-400 transition-colors duration-150 ease-exec hover:text-navy" data-id="element-165" data-mp="1a5gisklunxuw">
              {link.label}
            </a>)}
          <button type="button" onClick={onRequestBriefing} className="focus-ring rounded-sm bg-navy px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-exec hover:bg-navy-700" data-id="element-166" data-mp="uh1y5pw6oyhq">
            Request Briefing
          </button>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="focus-ring rounded-sm p-2 text-navy lg:hidden" data-id="element-167" data-mp="zdio8pmy1mxg">
          {open ? <XIcon className="h-5 w-5" data-id="element-168" data-mp="1n45xbe8liill" /> : <MenuIcon className="h-5 w-5" data-id="element-169" data-mp="1n2bkyobe3yt4" />}
        </button>
      </div>

      {open ? <div id="mobile-nav" className="border-t border-steel-100 bg-white px-6 pb-6 pt-2 lg:hidden" data-id="element-170" data-mp="1i3i5wrggfzqu">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-171" data-mp="3jx7qfn0pk5ws">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="focus-ring border-b border-steel-100 py-3 text-sm font-medium text-navy" data-id="element-172" data-mp="1zf5i7grrzb3n">
                {link.label}
              </a>)}
          </nav>
          <button type="button" onClick={() => {
        setOpen(false);
        onRequestBriefing();
      }} className="focus-ring mt-4 w-full rounded-sm bg-navy px-5 py-3 text-sm font-semibold text-white" data-id="element-173" data-mp="1un5erechy02b">
            Request Briefing
          </button>
        </div> : null}
    </header>;
}